import { FeatureFlag } from '../FeatureFlag';

export const enableLlmNlp = new FeatureFlag({
    key: 'enable-llm-nlp',
    defaultValue: false,
});
